import { createApi } from '@reduxjs/toolkit/query/react';
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';
import { client } from 'graphql/client';
import { listRoles } from 'graphql/queries';
import { z } from 'zod';

import { errorHandler } from './errors';

import type { SystemRole } from 'API';
import { SystemRoleSchema } from 'APIzod';

const listRolesFn = async () => {
    try {
        const { data } = await client.graphql({ query: listRoles });
        return { data: z.array(SystemRoleSchema()).parse(data.listRoles) };
    } catch (error) {
        throw errorHandler('Unexpected error occurred while getting the roles', error);
    }
};

export const authApi = createApi({
    reducerPath: 'auth',
    baseQuery: graphqlRequestBaseQuery({
        url: '/graphql',
    }),
    refetchOnMountOrArgChange: true,
    endpoints: builder => ({
        listRoles: builder.query<SystemRole[], string>({
            queryFn: listRolesFn,
        }),
    }),
});

export const { useListRolesQuery } = authApi;
